if (!customElements.get('extended-dialog')) {
  /**
   * The ExtendedDialog class is a class for extended dialog tag.
   */
  class ExtendedDialog extends HTMLElement {
    /**
     * The constructor method is a special method of a class for creating
     * and initializing an object instance of that class.
     */
    constructor() {
      super();
      const dialogs = this.querySelectorAll('dialog');
      dialogs.forEach((dialog) => {
        ExtendedDialog.setEventListener(dialog);
        ExtendedDialog.close(dialog);
      });
    }

    /**
     * The close method is a special method of a class for set dialog
     * close event to element with attributes close and overlay.
     * @name close
     * @kind function
     * @param {HTMLDialogElement} dialog The HTML dialog element.
     */
    static close(dialog) {
      dialog.querySelectorAll('[close]').forEach((el) => el.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', (event) => {
        if(event.target.nodeName == 'DIALOG') dialog.close();
      });
    }

    /**
     * The setEventListener method is a special method of a class for set
     * event listener on dialog close and open.
     * @name setEventListener
     * @kind function
     * @param {HTMLDialogElement} dialog The HTML dialog element.
     */
    static setEventListener(dialog) {
      new MutationObserver(() => document.dispatchEvent(
        new CustomEvent(`dialog:${dialog.getAttribute('open') === null ? 'close' : 'open'}`, {
          detail: { dialog },
        }),
      )).observe(dialog, { attributeFilter: ['open'] });
    }
  }

  customElements.define('extended-dialog', ExtendedDialog);
}
